import { Component, inject } from '@angular/core';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { IntelligenceTabComponent } from './intelligence-tab/intelligence-tab.component';
import { Route } from '../../utils/route';

@Component({
  selector: 'app-intelligence',
  imports: [TabsComponent, IntelligenceTabComponent],
  templateUrl: './intelligence.component.html',
  styleUrl: './intelligence.component.scss',
})
export class IntelligenceComponent extends Route {}
